import { FC, ReactNode } from 'react'

interface IPublic {
  children?: ReactNode
}

const Public: FC<IPublic> = ({ children }) => {
  return <>{children}</>
}

export default Public
